/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { withTheme } from 'styled-components';
import Popover from 'react-tiny-popover';
import { Helper, PlusIcon, PopoverContent, PopoverButton } from './DropdownInput.styled';

class DropdownInput extends Component {
  state = {
    selectedAnswer: this.props.value,
    isPopoverOpen: false
  };

  onOptionSelect = selectedAnswer => {
    this.setState({ selectedAnswer: selectedAnswer.value });
  };

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ selectedAnswer: this.props.value });
    }
  }

  onStateChange = state => {
    if (typeof state.isOpen === 'undefined') {
      return;
    }
    this.setState({ isPopoverOpen: state.isOpen });
  };

  render() {
    let {
      name,
      placeholder,
      answeredPlaceholder,
      onChange,
      disabled,
      isMatching,
      matchingAnswer,
      popoverPosition
    } = this.props;
    let { selectedAnswer, isPopoverOpen } = this.state;
    if (matchingAnswer) {
      selectedAnswer = matchingAnswer;
    }
    return (
      <Helper isMatching={isMatching}>
        <Downshift
          name={name}
          onChange={onChange}
          selectedItem={selectedAnswer}
          disabled={disabled}
          onSelect={this.onOptionSelect}
          itemToString={data => (data ? data.value : '')}
          onStateChange={this.onStateChange}
        >
          {({
            isOpen,
            getToggleButtonProps,
            getItemProps,
            highlightedIndex,
            getLabelProps,
            getMenuProps,
            getRootProps
          }) => (
            <div
              title={selectedAnswer || placeholder}
              className={matchingAnswer ? 'chosen-answer dropdown' : 'dropdown'}
            >
              <button
                {...getToggleButtonProps({
                  'aria-label': !selectedAnswer ? placeholder : answeredPlaceholder + selectedAnswer
                })}
                {...getLabelProps()}
                {...getRootProps({}, { suppressRefError: true })}
                tabIndex="1"
                disabled={disabled}
                className={`dropdown-button ${!selectedAnswer ? ' empty' : 'dropdown-button'}`}
              >
                {selectedAnswer || placeholder}
                <span className={isOpen ? 'dropdown-arrow is-open' : 'dropdown-arrow'} />
                {isMatching && <PlusIcon size={10} name="plus" />}
              </button>
              {isMatching && matchingAnswer && <div className="chosen-value">{matchingAnswer}</div>}
              <Popover
                tabIndex="1"
                {...getMenuProps()}
                isOpen={isPopoverOpen}
                position={popoverPosition} // preferred position
                padding={0}
                align={'start'}
                transitionDuration={0.15}
                containerStyle={{ zIndex: 10, marginTop: '-5px' }}
                content={
                  <PopoverContent tabIndex="1" isMatching={isMatching}>
                    <div className="downshift-dropdown">
                      {this.props.data.map((item, index) => (
                        <div
                          key={index}
                          tabIndex="1"
                          role="button"
                          className={
                            !isMatching
                              ? selectedAnswer === item.value
                                ? 'dropdown-item selected'
                                : 'dropdown-item'
                              : item.selected.length
                              ? item.current
                                ? 'dropdown-item current-selected'
                                : 'dropdown-item selected current'
                              : 'dropdown-item'
                          }
                          style={{
                            color:
                              highlightedIndex === index ? this.props.theme.colors.mainColor : null
                          }}
                          {...getItemProps({
                            key: index,
                            index,
                            item,
                            'aria-label': `${index + 1} of ${this.props.data.length}`
                          })}
                        >
                          {item.value}
                        </div>
                      ))}
                    </div>
                  </PopoverContent>
                }
              >
                <PopoverButton>{}</PopoverButton>
              </Popover>
            </div>
          )}
        </Downshift>
      </Helper>
    );
  }
}

DropdownInput.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  answeredPlaceholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  theme: PropTypes.object,
  isMatching: PropTypes.bool,
  matchingAnswer: PropTypes.string,
  popoverPosition: PropTypes.array
};

export default withTheme(DropdownInput);
